import { render, staticRenderFns } from "./Extention.vue?vue&type=template&id=bcbec570"
import script from "./Extention.vue?vue&type=script&lang=js"
export * from "./Extention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports